@for (banner of banners$ | async; track banner) {
  <div
    class="banner"
    [ngClass]="'banner--' + banner.level"
    [attr.role]="banner.level === 'error' ? 'alert' : 'status'"
    [attr.tabindex]="banner.focusOnShow ? 0 : -1"
  >
    <div class="banner__content">
      <span class="banner__icon" aria-hidden="true"></span>
      <span class="banner__text">{{ banner.message }}</span>
    </div>
    @if (banner.ctAs?.length) {
      <div class="banner__ctas">
        @for (c of banner.ctAs; track c) {
          <sui-button
            [variant]="c.type === 'primary' ? 'primary' : 'secondary'"
            (click)="onCta(c)"
          >
            {{ c.label || (c.i18nKey ? (c.i18nKey | translate: c.meta) : "") }}
          </sui-button>
        }
      </div>
    }
    <button
      class="banner__close"
      aria-label="Dismiss"
      (click)="dismiss(banner.id)"
    >
      ×
    </button>
  </div>
}
